import { render, staticRenderFns } from "./PartnerRegisterTab.vue?vue&type=template&id=be26f5d0&scoped=true&"
import script from "./PartnerRegisterTab.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be26f5d0",
  null
  
)

export default component.exports